import { useContext } from 'react'
import { Container } from 'react-bootstrap'
import { Outlet, useLocation } from 'react-router-dom'
import { UserContext } from '../../context/userContext'
import '../../styles/style.css'
import NavbarMover from './NavbarMover'

const DashboardMover = () => {
  const [state] = useContext(UserContext)
  const { pathname } = useLocation()
  const containerClass =
    pathname === '/mover/detail'
      ? 'p-0 min-vh-100 half-background-detail-mover'
      : 'p-0 min-vh-100'

  return (
    <div
      className={`d-flex flex-column min-vh-100 ${containerClass}`}
      style={{ backgroundColor: pathname === '/mover/detail' ? '' : '#f5f6fa' }}
    >
      <div style={{ zIndex: 1030 }}>
        <NavbarMover user={state.username} />
      </div>
      <Container fluid className="flex-grow-1 py-3 px-3 px-md-4">
        <Outlet />
      </Container>
    </div>
  )
}

export default DashboardMover
